module.exports = "<router-outlet>\n  <livechat-widget licenseId=\"7424591\"></livechat-widget>\n  <div class=\"live_chat\" [hidden]=\"!showChat\">\n    <div data-id=\"PegLksDWMkR\" class=\"livechat_button\">\n      <a\n        href=\"https://www.livechatinc.com/?utm_source=chat_button&utm_medium=referral&utm_campaign=lc_7424591\"\n      ></a>\n    </div>\n  </div>\n</router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /var/www/html/LASO/laso-client/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main